<template>
	<div class="modal fade innerpageModal show" tabindex="-1" style="display:block">
		<div class="modal-dialog" role="document">
			<div class="modal-content depositAllow">
				<loader v-show="pageLoader" class="w-100"></loader>
				<div class="modal-header border-0">
					<h5 class="modal-title" id="exampleModalLabel">Deposit</h5>
					<button type="button" class="close" @click="$parent.deposit_currency = ''">
					  	<span aria-hidden="true">&times;</span>
					</button>
				</div>  
				<div class="scrollbar Mob">
					<div class="modal-body" v-if="!crypto">
						<alert-notification v-if="notification_msg != ''"/>
						<div class="crptoIcon-dep">
							<span>
								<img :src="'../../../../static/website/images/crypto_logos/'+getCurrency+'.png'" alt="BTC" @error="handleImgErr($event)" v-if="!imageError">
		                        <span class="firstName" v-else>{{getCurrency.charAt(0).toUpperCase()}}</span>
							</span>
							<p>{{currencyName}}</p>
						</div> 
						<!-- <div class="midContent section_title mb-0 text-center">
							<h5>Important deposit instructions</h5>
							<p>Your deposit address on the blockchain must hold more than 0.1 1ST before we will credit your account.</p>
						</div> -->
						<div class="list-group-item head d-flex justify-content-between align-items-center" v-if="parseInt(get_user.tier) == 5">
							<div>
								<p class="mr-3">
									<strong>BSB</strong>
									<span>{{$env_var.DepositBankData[getCurrency.toUpperCase()].BSB}}</span>
								</p>
								<p>
									<strong>Account Number</strong>
									<span>{{$env_var.DepositBankData[getCurrency.toUpperCase()].AccNO}}</span>
								</p>
								<p>
									<strong>SWIFT code</strong>
									<span>{{$env_var.DepositBankData[getCurrency.toUpperCase()].SWIFT}}</span>
								</p>
							</div>
						</div>
						<div class="midContent section_title mb-0 text-center" v-else-if="[2,4].includes(parseInt(get_user.tier))">
							<p v-if="parseInt(get_user.tier) == 2">Your account verification is under process please wait till it's complete..</p>
							<p v-if="parseInt(get_user.tier) == 4">Your Bank verification is under process..</p>
						</div>
						<div class="midContent section_title mb-0 text-center" v-else-if="[1,3].includes(parseInt(get_user.tier))">
							<p v-if="parseInt(get_user.tier) == 1">Please Complete your registration steps first , before proceeding to deposit</p>
							<p v-if="parseInt(get_user.tier) == 3">Please Add Bank account to deposit fiat Currencies</p>
						</div>
					</div>
					<div class="modal-body" v-if="crypto">
						<alert-notification v-if="notification_msg != ''"/>
						<div class="crptoIcon-dep">
							<!-- <span><img src="../../../../static/website/images/crypto_logos/btc.png" alt="BTC"></span>
							<p>Bitcoin</p> -->
							<span v-if="getCurrency">
								<img  class="ml-2" :src="'../../../../static/website/images/crypto_logos/'+getCurrency+'.png'" :alt="getCurrency" @error="handleImgErr($event)" v-if="!imageError">
		                        <span class="firstName" v-else>{{getCurrency.charAt(0).toUpperCase()}}</span>
							</span>
							<p>{{currencyName}}</p>
						</div>
						<div class="midContent section_title mb-0 text-center">
							<h5>Important deposit instructions</h5>
							<!-- <p>Your deposit address on the blockchain must hold more than 0.1 1ST before we will credit your account.</p> -->
							<p>Incoming transactions show up in your wallet after they have been confirmed on the network.</p>
						</div>
						<div v-if="!['EOS','XLM'].includes(getCurrency.toUpperCase())">
							<div class="midContent section_title mb-0 text-center">
								<div class="formLabel copyAddress text-left">
									<label>Wallet Address</label>
									<div class="midCopy position-relative">
										<div class="copied"  v-if="copy_msg1">
											<span>Copied</span>
										</div>
										<p>{{(generateWalletAddress)?generateWalletAddress:'-'}}</p>
										<button class="copy"  :class="(generateWalletAddress)?'enabled':'disabled'" v-clipboard:copy="generateWalletAddress" v-clipboard:success="onCopy" v-clipboard:error="onError">
											<feather type="copy"></feather>
										</button>
									</div>
								</div>
							</div>
						</div>
						<div v-else>
							<div class="midContent section_title mb-0 text-center">
								<div class="formLabel copyAddress text-left">
									<label>Wallet Address</label>
									<div class="midCopy position-relative">
										<div class="copied"  v-if="copy_msg1">
											<span>Copied</span>
										</div>
										<p>{{(generateWalletAddress)?generateWalletAddress.split("?")[0]:'-'}}</p>
										<button class="copy"  :class="(generateWalletAddress)?'enabled':'disabled'" @click="copyText = '1'" v-clipboard:copy="(generateWalletAddress)?generateWalletAddress.split('?')[0]:'-'" v-clipboard:success="onCopy" v-clipboard:error="onError">
											<feather type="copy"></feather>
										</button>
									</div>
								</div>
							</div>
							<div class="midContent section_title mb-0 text-center">
								<div class="formLabel copyAddress text-left">
									<label>Memo ID</label>
									<div class="midCopy position-relative">
										<div class="copied"  v-if="copy_msg2">
											<span>Copied</span>
										</div>
										<p>{{getMemoId(generateWalletAddress) || '-'}}</p>
										<button class="copy"  :class="(getMemoId(generateWalletAddress))?'enabled':'disabled'" @click="copyText = '2'" v-clipboard:copy="getMemoId(generateWalletAddress)" v-clipboard:success="onCopy" v-clipboard:error="onError">
											<feather type="copy"></feather>
										</button>
									</div>
								</div> 
							</div> 
						</div>

						
						<div class="text-right border-0 pt-0 pb-4" >  
							<router-link :to="{name: 'support' , params: { 'tabName':'requestServiceElement','page':getCurrency.toUpperCase(), 'ticketData' : '5','method_id':'69'}}" class="green">Get New Address</router-link> 
						</div> 
						
						<div class="alrtMessage position-relative pl-5 pr-3 py-3 alert alert-warning mt-5">
	                    <p>
	                        <feather class="alertIcon tp" size="20px" type="alert-octagon"></feather>Kindly ensure that you deposit to the correct currency type to this wallet. <br>
							Example: Only deposit BTC into a wallet created for BTC. If you have mistakenly sent funds to the wrong wallet address, you risk losing your funds permanently.</p>

							<p class="mb-0 ">And please refer to the supported countries list to understand your deposit and withdrawal limits. Know more!</p>
	                    </div>
					</div>
					<!-- <p class="error" v-if="$parent.raised_max_limit_msg != ''">{{$parent.raised_max_limit_msg}}</p> -->
					<!-- <div v-if="$parent.get_method_id != '' && parseInt($parent.get_method_id) == 1">
						<div v-if="withdrawalMethodResponse != '' && withdrawalMethodResponse.hasOwnProperty(1)">
							<div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center">
								<div class="list-group-item w-100">
									<span>Processing Time: <strong>1 to 5 working days</strong></span>
									<span>Fee: <strong>0</strong></span>
								</div>
							</div>
							<div >
								<p class="mb-2">Our Bank details are:</p>
								<div v-for="(list,index) in $env_var.depositBankListDetail" class=" mb-3">
									<div class="list-group-item head ">
										<div class="d-flex justify-content-between align-items-center">
											<div>
												<p ><span>{{list.region}}</span></p>
											</div>
											<div>
												<a href="#" class="green" @click="detailDiv(index);" v-if="index == showIndex">Less Detail</a>
												<a href="#" class="green" @click="detailDiv(index);" v-else>View Detail</a>
											</div>
										</div>
										
										<div class="border p-2 mt-2 whiteBG w-100 radius">
											
											<p v-if="list.region == 'Moneynetint'">
												<span>Minimum Deposit Amount: <b>&euro; 1000 </b> </span>
											</p>
											
											<p v-else>
												<span>Minimum Deposit Amount: <b>&euro; 5 </b> </span><br>
											</p>
										</div>
									</div>
									<div class="personalForm list-group mb-3" :ref="'buttons'+index" v-if="index == showIndex">
										
										<div>
											<div class="list-group-item">
											   <span>IBAN</span>  <span>{{list.IBAN}}</span>
											</div>
											<div class="list-group-item">
											   <span>Account Number</span>  <span>{{list.account_number}}</span>
											</div>
											<div class="list-group-item">
											   <span>Holder Name:</span>  <span>{{list.account_holder_name}}</span>
											</div>
											<div class="list-group-item">
											   <span>Bank Name:</span>  <span>{{list.Bank_Name}}</span>
											</div>
											<div class="list-group-item">
											   <span>Swift/BIC</span>  <span>{{list.SWIFT}}</span>
											</div> 
											<div class="list-group-item">
											   <span>Address</span>  <span>{{list.address}}</span>
											</div>
										</div>
									</div>
								</div> 
								<p class="mb-3" >For payments via Deutsche HandelsBank a fee of &euro;20 will be charged if deposit amount is less than the minimum deposit amount.</p>
								<p class="mb-3" v-if="$env_var.depositBankListDetail.length > 0">In case you wish to transfer from a bank account other than mentioned in your profile, please <router-link :to="{name: 'fxView.support' , params: { 'tabName':'requestServiceElement','ticketData' : '16','method_id':get_method_id}}">Click Here </router-link> to add the new bank account details </p>
								
							</div>
							<div class="mb-3" v-if="!(withdrawalMethodResponse.hasOwnProperty(1)) && $env_var.depositBankListDetail.length == 0">
								<p>You don't have a bank verified yet. Kindly<router-link  :to="{name: 'support' , params: { 'tabName':'requestServiceElement','ticketData' : '16','method_id':1}}">Click Here</router-link> to add the new bank. In case you have already added your bank details, please wait for them to get verified.</p>
							</div>
						</div>
						<div class="mb-3" v-else>
							<p>you don't have any bank account , please <router-link :to="{name: 'support' , params: { 'tabName':'requestServiceElement','ticketData' : '16','method_id':1}}">Click Here</router-link> to create new bank</p>
						</div>
					</div> -->
					
					<div class="modal-footer justify-content-center border-0 pt-0 pb-4" v-if="!crypto && [1,3].includes(parseInt(get_user.tier))">
						<button type="button" class="cap_btn blue"  @click="withdrawLimit()">{{(parseInt(get_user.tier) <= 2)?'Complete registration steps':'Add Bank' }}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
    import { depositWithdrawalMixins } from '@/plugins/depositWithdrawal'
    import { Const } from '@/plugins/depositWithdrawal/provider/lib/const.cls.ts'
	import tradingMixins from '@/plugins/trading';
    export default {
        name: 'Deposit',
        mixins: [depositWithdrawalMixins,tradingMixins],
        data() {
            return {
				//platformIcon : {'MT4' : 'platforn-icon-1.svg' , 'MT5' : 'platforn-icon-3.svg','ACT' : 'platforn-icon-2.svg'},
				// showIndex : '-1'
				pageLoader : false,
				notification_msg:'',
            	notification_type:'',
				notCryptoCurrency:['EURO','USD','AUD','GBP','JPY'],
				crypto : false,
				copy_msg1 : false,
				copy_msg2 : false,
				copyText : '1',
				imageError : false,
				interval:'',
				
            }
        },
        props:['getCurrency' ,'currencyName'],
        methods:{
			getMemoId(val){
				try{
					return val.split("?")[1].split("=")[1]
				}catch(e){ return null}
			},
        	handleImgErr(val){
				this.imageError = true
			},
        	transactionLimitCurrency(clear){
				// this.get_method_id	= this.$env_var.bankCurrencyList.hasOwnProperty(getCurrency) ? 1 : 11;
				//clean state variable
				
				if(clear){
					this.$store.commit(Const.SET_GENERATE_WALLET_ADDRESS, '')
				}
				// this.currency_selected  = this.getCurrency
				if(this.notCryptoCurrency.includes(this.getCurrency.toUpperCase())){
					//alert('fiat currency')
					this.crypto = false
				}else{
					// console.log('currency',this.getCurrency)
					this.crypto = true
					this.getAddress()
					/*if(this.tradingAccount.length > 0 && 'subAccounts' in this.tradingAccount[0] ){
						this.getAddress()
					}else{
						this.pageLoader = true
						var i = 0, _that = this;
						this.interval = setInterval(function(){
							console.log('->',i)
							if(_that.tradingAccount.length > 0 && 'subAccounts' in _that.tradingAccount[0] ){
								_that.getAddress()
								clearInterval(_that.interval)
							}else if(i == 6){
								_that.getAddress()
								clearInterval(_that.interval)
							}
							i++
						}, 500);
					}*/
				}
			},
			getAddress(){
				var account_id  = ''
				if(this.tradingAccount.length > 0  ){
					this.tradingAccount[0].subAccounts.forEach(value =>{
						if(this.getCurrency.toLowerCase() == value.currency.toLowerCase()){
							account_id = value.act_account_id
						}
					})
				}
				this._runGenerateWalletAddress({'globalParams' :{'currency' : this.getCurrency , 'act_account_id' :account_id},'localParams' :{ "parameter" : this }})
			},
			onCopy(e) {
				if(this.copyText = '1'){
					this.copy_msg1 = true
				}else{
					this.copy_msg2 = true
				}
			    var _that = this
				setTimeout(function() { 
					_that.copy_msg1 = false
					_that.copy_msg2 = false
					// $(".copied").fadeOut(1500); 
				}, 2000)
				
            },
            onError(e) {
                /*this.$notify({
			        group: 'foo',
			        type: 'error',
			        text: 'Address not Copied',
			        duration: 10000,
			        closeOnClick: true
			    });*/
			    var _that = this
				try{
			        _that.notification_msg = 'Address not Copied' ;
			        _that.notification_type = 'error' ;

			        setTimeout(function(){
			            _that.notification_msg = '' ;
			            _that.notification_type = '' ;
			        }, 5000);
			    }catch(e){}
            }

        },
        created(){
        	this.transactionLimitCurrency(true)
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/website/deposit-withdrawal/popup_deposit.vue